import React from 'react';
import {Card} from 'react-bootstrap';
import {BingoTheme} from '../types';

const logoColorido = '/assets/images/logo-colorido.svg';
const logoPB = '/assets/images/logo-pb.svg';

interface BingoPreviewProps {
    title: string;
    type: 'numbers' | 'names';
    names: string;
    image?: string;
    theme: BingoTheme;
}

const BingoPreview: React.FC<BingoPreviewProps> = ({title, type, names, image, theme}) => {
    console.log(
        "[DEBUG_LOG] BingoPreview - Rendering preview for title:",
        title
    );

    const renderGrid = () => {
        const rows = [];
        const header = ["B", "I", "N", "G", "O"];

        const namesList = names.split(',').map(n => n.trim()).filter(n => n !== '');

        // Use a fixed seed or static values for preview to avoid flickering
        const staticNumbers = [
            [1, 18, 32, 47, 62],
            [5, 22, 35, 50, 65],
            [9, 25, 38, 53, 68],
            [12, 28, 41, 56, 71],
            [15, 30, 45, 60, 75]
        ];

        const isHighContrast = theme.id === 'high-contrast' || theme.id === 'default';
        // Render header row
        const headerCells = header.map((cell, j) => {
            return (
                <div key={`header-${j}`}
                     className={`bingo-preview-cell ${j === 0 ? 'cell-first' : ''} cell-every header`}>
                    <span className="cell-content"
                          style={{color: isHighContrast ? theme.primary : theme.secondary}}>{cell}</span>
                </div>
            );
        });
        rows.push(
            <div key="header-row" className="bingo-preview-row"
                 style={{
                     backgroundColor: isHighContrast ? theme.secondary : theme.primary,
                     color: isHighContrast ? theme.primary : theme.secondary,
                     borderBottom: isHighContrast ? `2px solid ${theme.primary}` : 'none'
                 }}>
                {headerCells}
            </div>
        );

        // Render data rows
        for (let i = 0; i < 5; i++) {
            const cells = [];
            for (let j = 0; j < 5; j++) {
                const isImageCell = i === 2 && j === 2;
                const cellClasses = `bingo-preview-cell ${j === 0 ? 'cell-first' : ''} cell-every`;
                const cellStyle: React.CSSProperties = {
                    borderColor: theme.primary,
                    backgroundColor: theme.secondary,
                    color: theme.primary,
                };

                if (isImageCell) {
                    cells.push(
                        <div key={`${i}-${j}`} className={cellClasses}
                             style={{...cellStyle, minHeight: '55px', height: 'auto'}}>
                            {image ? (
                                <img src={image} alt="Center" className="bingo-preview-image"/>
                            ) : (
                                <span className="cell-content"></span>
                            )}
                        </div>
                    );
                } else {
                    let content = "";
                    if (type === 'numbers') {
                        content = staticNumbers[i][j].toString();
                    } else {
                        const flatIdx = i * 5 + j;
                        let nameIdx = flatIdx;
                        if (flatIdx > 12) nameIdx = flatIdx - 1;

                        content = namesList.length >= 24 ? namesList[nameIdx] : "?";
                    }
                    cells.push(
                        <div key={`${i}-${j}`} className={cellClasses}
                             style={{...cellStyle, minHeight: '55px', height: 'auto'}}>
                            <span className="cell-content" style={{color: theme.primary}}>{content}</span>
                        </div>
                    );
                }
            }
            rows.push(
                <div key={i} className="bingo-preview-row" style={{borderColor: theme.primary,}}>
                    {cells}
                </div>
            );
        }
        return rows;
    };

    return (
        <div className="d-flex flex-column align-items-center p-3 rounded-3"
             style={{backgroundColor: 'var(--bingo-card-bg)'}}>
            <div className="bingo-preview-card" style={{borderColor: theme.primary}}>
                <div className="bingo-preview-title" style={{color: theme.primary}}>{title || 'BINGO'}</div>
                <div className="bingo-preview-subtitle" style={{color: theme.primary}}>Crie sua cartela em
                    gritebingo...
                </div>
                <div className="bingo-preview-grid" style={{borderColor: theme.primary}}>
                    {renderGrid()}
                </div>
            </div>
            <p className="mt-3 small text-center px-4" style={{color: 'var(--bingo-text-muted)'}}>
                Esta é uma visualização rápida não exata do resultado, avalie com cautela o pdf gerado ANTES da
                impressão.
            </p>
        </div>
    );
};

export default BingoPreview;
